import {
  ChangeDetectionStrategy,
  Component,
  inject,
  forwardRef,
  OnInit,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { MyHttpClientFactory, ResponseCasingEnum } from '@ups/xplat/core';
import { DynamicTypeaheadWebBaseComponent } from '../base/dynamic-typeahead.web-base-component';

const SEARCH_CONTROL_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => DynamicTypeaheadIconsComponent),
  multi: true,
};

@Component({
  selector: 'ups-dynamic-typeahead-icons',
  templateUrl: 'dynamic-typeahead-icons.component.html',
  providers: [SEARCH_CONTROL_VALUE_ACCESSOR],
  // WI 35909 (S1): template state is marked at each async write in the shared typeahead bases
  // (WI 35584); this subclass adds no template-read async writes of its own.
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DynamicTypeaheadIconsComponent
  extends DynamicTypeaheadWebBaseComponent
  implements OnInit
{
  protected http: HttpClient;

  private readonly clientFactory = inject(MyHttpClientFactory);

  ngOnInit() {
    super.ngOnInit();
    if (this.config.options) {
      if (this.config.options.api) {
        this.http = this.clientFactory.createHttpClient(
          this.config.options.api.host,
          true,
          ResponseCasingEnum.CamelCase
        );
        this.searchQuery = this.http.get.bind(
          this.http,
          this.config.options.api.endpoint
        );
      }
    }
  }
}
